// import { useQuery } from "@tanstack/react-query";
// import { Form, Input, InputNumber, Select, TimePicker } from "antd";
// import type { FormInstance } from "antd";
// import { getPhonebook } from "../../../services/adminController";

// const { Option } = Select;

// interface CreateCampaignFormProps {
//   form: FormInstance;
//   phonebooks?: {
//     id: string | number;
//     name: string;
//   }[];
// }

// import axios from "axios";

// export const CREATE_CAMPAIGN =
//   "/dialer/campaigns";

// export interface CreateCampaignPayload {
//   campaigns: {
//     active_time_end: string;
//     active_time_start: string;
//     campaign_type: string;
//     dialing_ratio: string;
//     name: string;
//     phonebook_id: string;
//     retry_attempt: number;
//     retry_interval_sec: number;
//     status: string;
//     trunk: string;
//   }[];
// }

// export async function createCampaign(
//   payload: CreateCampaignPayload
// ) {
//   const res = await axios.post(
//     CREATE_CAMPAIGN,
//     payload
//   );

//   if (res.status >= 200 && res.status < 300) {
//     return res.data;
//   }

//   throw new Error(
//     "Failed to create campaign"
//   );
// }

// const CreateCampaignForm = ({
//   form,

// }: CreateCampaignFormProps) => {

//   const {
//     data: phonebooks,
//     isLoading,
//     isError,
//     error,
//   } = useQuery({
//     queryKey: ["phonebookSolveesy"],
//     queryFn: getPhonebook,
//   });

// console.log(phonebooks,"phonebooks")
//   return (
//     <Form
//       layout="vertical"
//       form={form}
//       autoComplete="off"
//       initialValues={{
//         campaign_type: "Fixed",
//         dialing_ratio: "Input",
//         status: "active",
//         trunk: "default",
//       }}
//     >
//       {/* Campaign Name */}
//       <Form.Item
//         name="name"
//         label="Campaign Name"
//         rules={[
//           {
//             required: true,
//             message: "Please enter campaign name",
//           },
//         ]}
//       >
//         <Input placeholder="Enter campaign name" />
//       </Form.Item>

//       {/* Active Time Start */}
//       <Form.Item
//         name="active_time_start"
//         label="Active Time Start"
//         rules={[
//           {
//             required: true,
//             message: "Please select start time",
//           },
//         ]}
//       >
//         <TimePicker
//           style={{ width: "100%" }}
//           use12Hours
//           format="h:mm a"
//           placeholder="Select start time"
//         />
//       </Form.Item>

//       {/* Active Time End */}
//       <Form.Item
//         name="active_time_end"
//         label="Active Time End"
//         rules={[
//           {
//             required: true,
//             message: "Please select end time",
//           },
//         ]}
//       >
//         <TimePicker
//           style={{ width: "100%" }}
//           use12Hours
//           format="h:mm a"
//           placeholder="Select end time"
//         />
//       </Form.Item>

//       {/* Dialing Ratio */}
//       <Form.Item
//         name="dialing_ratio"
//         label="Dialing Ratio"
//         rules={[
//           {
//             required: true,
//             message: "Please enter dialing ratio",
//           },
//         ]}
//       >
//         <Input placeholder="Enter dialing ratio" />
//       </Form.Item>

//       {/* Phonebook */}
//       <Form.Item
//         name="phonebook_id"
//         label="Phonebook"
//         rules={[
//           {
//             required: true,
//             message: "Please select phonebook",
//           },
//         ]}
//       >
//         <Select
//           placeholder="Select phonebook"
//           showSearch
//           optionFilterProp="children"
//         >
//           {/* {phonebooks.map((phonebook) => (
//             <Option key={phonebook.id} value={phonebook.id}>
//               {phonebook.name}
//             </Option>
//           ))} */}
//         </Select>
//       </Form.Item>

//       {/* Retry Attempts */}
//       <Form.Item
//         name="retry_attempt"
//         label="Retry Attempts"
//         rules={[
//           {
//             required: true,
//             message: "Please enter retry attempts",
//           },
//         ]}
//       >
//         <InputNumber
//           style={{ width: "100%" }}
//           min={0}
//           placeholder="Enter retry attempts"
//         />
//       </Form.Item>

//       {/* Retry Interval */}
//       <Form.Item
//         name="retry_interval_sec"
//         label="Retry Interval (Seconds)"
//         rules={[
//           {
//             required: true,
//             message: "Please enter retry interval",
//           },
//         ]}
//       >
//         <InputNumber
//           style={{ width: "100%" }}
//           min={0}
//           placeholder="Enter retry interval in seconds"
//         />
//       </Form.Item>

//       {/* Hardcoded / Hidden Fields */}
//       <Form.Item name="status" hidden>
//         <Input />
//       </Form.Item>

//       <Form.Item name="campaign_type" hidden>
//         <Input />
//       </Form.Item>

//       <Form.Item name="trunk" hidden>
//         <Input />
//       </Form.Item>
//     </Form>
//   );
// };

// export default CreateCampaignForm;


import { useQuery } from "@tanstack/react-query";
import {
  Alert,
  Form,
  Input,
  InputNumber,
  Select,
  Spin,
  TimePicker,
} from "antd";

import type { FormInstance } from "antd";

import { getPhonebook } from "../../../services/adminController";

const { Option } = Select;

interface Phonebook {
  phonebookname: any;
  id: string | number;
  name: string;
}

interface CreateCampaignFormProps {
  form: FormInstance;
}

const CreateCampaignForm = ({
  form,
}: CreateCampaignFormProps) => {
  /**
   * =====================================================
   * GET PHONEBOOKS
   * =====================================================
   */

  const {
    data: phonebooksResponse,
    isLoading: isPhonebooksLoading,
    isError: isPhonebooksError,
    error: phonebooksError,
  } = useQuery({
    queryKey: ["phonebookSolveesy"],
    queryFn: getPhonebook,
  });

  /**
   * =====================================================
   * PHONEBOOK DATA
   * =====================================================
   *
   * Assuming getPhonebook() returns:
   *
   * {
   *   data: [...]
   * }
   *
   * If your response is directly an array,
   * use:
   *
   * const phonebooks = phonebooksResponse ?? [];
   */

  const phonebooks: Phonebook[] =
    phonebooksResponse?.data ?? [];


  return (
    <Form
      layout="vertical"
      form={form}
      autoComplete="off"
      initialValues={{
        dialing_ratio: "1",
        retry_attempt: 0,
        retry_interval_sec: 0,
      }}
    >
      {/* =================================================
          CAMPAIGN NAME
          ================================================= */}

      <Form.Item
        name="name"
        label="Campaign Name"
        rules={[
          {
            required: true,
            message:
              "Please enter campaign name",
          },
        ]}
      >
        <Input
          placeholder="Enter campaign name"
        />
      </Form.Item>

      {/* =================================================
          ACTIVE TIME START
          ================================================= */}

      <Form.Item
        name="active_time_start"
        label="Active Time Start"
        rules={[
          {
            required: true,
            message:
              "Please select start time",
          },
        ]}
      >
        <TimePicker
          style={{
            width: "100%",
          }}
          use12Hours
          format="h:mm a"
          placeholder="Select start time"
        />
      </Form.Item>

      {/* =================================================
          ACTIVE TIME END
          ================================================= */}

      <Form.Item
        name="active_time_end"
        label="Active Time End"
        rules={[
          {
            required: true,
            message:
              "Please select end time",
          },
        ]}
      >
        <TimePicker
          style={{
            width: "100%",
          }}
          use12Hours
          format="h:mm a"
          placeholder="Select end time"
        />
      </Form.Item>

      {/* =================================================
          DIALING RATIO
          ================================================= */}

      <Form.Item
        name="dialing_ratio"
        label="Dialing Ratio"
        rules={[
          {
            required: true,
            message:
              "Please enter dialing ratio",
          },
        ]}
      >
        <Input
          placeholder="Enter dialing ratio"
        />
      </Form.Item>

      {/* =================================================
          PHONEBOOK
          ================================================= */}

      <Form.Item
        name="phonebook_id"
        label="Phonebook"
        rules={[
          {
            required: true,
            message:
              "Please select phonebook",
          },
        ]}
      >
        <Select
          placeholder="Select phonebook"
          showSearch
          loading={
            isPhonebooksLoading
          }
          disabled={
            isPhonebooksLoading ||
            isPhonebooksError
          }
          optionFilterProp="children"
          notFoundContent={
            isPhonebooksLoading ? (
              <Spin size="small" />
            ) : (
              "No phonebooks found"
            )
          }
        >
          {phonebooks.map(
            (phonebook) => (
              <Option
                key={phonebook.id}
                value={String(
                  phonebook.id
                )}
              >
                {phonebook?.phonebookname}
              </Option>
            )
          )}
        </Select>

        {isPhonebooksError && (
          <Alert
            className="mt-2"
            type="error"
            message="Failed to load phonebooks"
            description={
              phonebooksError instanceof
              Error
                ? phonebooksError.message
                : "Something went wrong"
            }
          />
        )}
      </Form.Item>

      {/* =================================================
          RETRY ATTEMPTS
          ================================================= */}

      <Form.Item
        name="retry_attempt"
        label="Retry Attempts"
        rules={[
          {
            required: true,
            message:
              "Please enter retry attempts",
          },
        ]}
      >
        <InputNumber
          style={{
            width: "100%",
          }}
          min={0}
          placeholder="Enter retry attempts"
        />
      </Form.Item>

      {/* =================================================
          RETRY INTERVAL
          ================================================= */}

      <Form.Item
        name="retry_interval_sec"
        label="Retry Interval (Seconds)"
        rules={[
          {
            required: true,
            message:
              "Please enter retry interval",
          },
        ]}
      >
        <InputNumber
          style={{
            width: "100%",
          }}
          min={0}
          placeholder="Enter retry interval in seconds"
        />
      </Form.Item>
    </Form>
  );
};

export default CreateCampaignForm;